<template>
    <div style="padding:12px">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="content">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="title">
                        选择权限
                    </div>
                    <el-tree class="filter-tree"
                             ref="tree"
                             :data="treeData"
                             :props="defaultProps"
                             node-key="id"
                             :expand-on-click-node='false'
                             show-checkbox
                             :default-checked-keys="checkedKeys"
                             :default-expanded-keys="['0']">
                        >
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span :title="data.name">{{ data.name }}</span>
                            </span>
                    </el-tree>
                </el-col>
                <el-col :span="12">
                    <div class="title">
                        已选择权限
                    </div>
                    <el-table
                        :height="windowHeight - 200"
                        :data="checkedPermission"
                        style="width: 100%"
                    >
                        <el-table-column
                            label="权限名称"
                            align="center"
                            prop="name"
                        >
                        </el-table-column>
                        <el-table-column
                            label="权限路径"
                            align="center"
                            prop="url"
                        >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';

    import {
        queryByModuleIdAndConstantId,
        queryPerBySchoolIdAndConstantId,
        updateModuleRolePermission
    } from '@/api/schoolManage';
    export default {
        name: 'schoolModuleRolePermissionEdit',
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                roleId: this.$route.query.roleId,

                moduleList: [],
                treeData: [],
                checkedKeys: [],
                checkedPermission: [],
                defaultProps: {
                    children: 'childrens',
                    label: 'name'
                },
                constantId: this.$route.query.constantId,
                moduleId: this.$route.query.moduleId
            }
        },
        components: {BackTool},
        created() {
            queryByModuleIdAndConstantId({
                moduleId: this.moduleId,
                constantId: this.constantId
            })
                .then(data => {
                    this.treeData = data;
                    queryPerBySchoolIdAndConstantId({
                        constantId: this.constantId,
                        moduleId: this.moduleId,
                        schoolId: this.schoolId
                    })
                        .then(data => {
                            if(data && data.length !== 0) {
                                this.checkedPermission = data;
                                const checkedKeys = [];
                                data.forEach(item => {
                                    const node = this.$refs.tree.getNode(item.id);
                                    if(node) {
                                        if(node.isLeaf) {
                                            checkedKeys.push(item.id);
                                        }
                                    }

                                });
                                this.checkedKeys = checkedKeys
                            }
                        })
                });

        },
        methods: {
            onsave() {
                if(this.$refs.tree.getCheckedKeys().filter(key => key != 0).join(',') === '') {
                    this.$message.error('请选择权限');
                } else {
                    updateModuleRolePermission({
                        moduleId: this.moduleId,
                        roleId: this.roleId,
                        schoolId: this.schoolId,

                        perList: [...this.$refs.tree.getCheckedKeys().filter(key => key != 0), ...this.$refs.tree.getHalfCheckedKeys().filter(key => key != 0)].join(',')
                    })
                        .then(() => {
                            this.$message.success('编辑成功');
                            setTimeout(() => {
                                this.$router.back();
                            }, 500);
                        })
                }
            }
        }
    }
</script>

<style scoped>
    .tree-container {
        margin-top: 8px;
    }
      .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
    .title {
        margin: 10px 0;
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionEdit.vue